import React from 'react';
import { Routes as RRDRoutes, Route, Outlet } from 'react-router-dom';
import {
  // Complementary activity links
  ComplementaryActivity,
  ComplementaryActivityDetails,
  ComplementaryActivityEvaluationView,
  ActivityEvaluationArchive,
  ActivityEvaluation,
  ActivityData,
  ViewActivity
} from '@/pages/complementary-activity';
import {
  // Quiz links
  Quiz,
  QuizData,
  QuizDataProposal,
  QuizDataOpenAnswers,
  QuizCreate
} from '@/pages/Quiz';
import {
  // Reports links
  Reports,
  ViewClassroom,
  ShowEmbed,
  LiveClassesReport,
  AccessReport,
  RegistrationReport,
  CourseProgressReport,
  EnemReport,
  AccessFunnelReport,
  LevelingTestReport,
  EssayReport,
  QuestionReports,
  LiveLessonsAccessReport,
  QuizReport,
  RecordClassesReport,
  StudentPage,
  GeneralRegistrationReport,
  Metrics1,
  MetricsProfile,
  SeducPi,
  SeducPiGeral,
  SeducPiGRE
} from '@/pages/reports';
import {
  // Participants links
  Participants,
  AdministrativeProfiles,
  ManageProfile,
  Notifications,
  NotificationExtract,
  CreateOrUpdateParticipant
} from '@/pages/Participants';
import { Dashboard, ViewEvent } from '@/pages/dashboard';
import {
  // Exams links
  Exams,
  ExamsResolution,
  ExamMetrics,
  ExamsAbout,
  ExamsQuestions,
  OfflineExam,
  PrintedExam,
  CreateExam,
  ManageExam,
  ExamMetricsList
} from '@/pages/exams';
import {
  // Mock exams links
  MockExamsAbout,
  CreateMockQuestionBook
} from '@/pages/mock-exams';
import PrivateRoute from './components/PrivateRoute';
import Terms from '@/pages/Terms';
import LoginCallback from '@/pages/LoginCallback';
import { LostPassword, SignIn } from '@/pages/Login/Login';
import OpenRegister from '@/pages/OpenRegister';
import OpenResults from '@/pages/OpenResults';
import OpenAnswerBook from '@/pages/OpenAnswerBook';
import Register from '@/pages/Register';
import { MyTasks, ViewTask } from '@/pages/MyTasks';
import { Feed, FeedPost } from '@/pages/feed';
import {
  // Course links
  Course,
  CourseMonitoring,
  CourseRecommended,
  CourseCertificate,
  CourseModuleAbout,
  CourseCreate,
  CourseClassroom,
  CourseManage,
  CourseAbout,
  CourseCreateActivity,
  CourseAdmin,
  CreateModule,
  CreateLesson,
  ManageModule,
  ShowCourse
} from '@/pages/course';
import {
  // LMS links
  LmsStudent,
  ViewModule,
  Lesson,
  LessonResources,
  ModuleCertificate
} from '@/pages/LmsStudent';
import { Profile } from '@/pages/profile';
import { UsersShow } from '@/pages/users';
import DashboardAdmin from '@/pages/Admin';
import {
  // Classrooms links
  Classrooms,
  ManageClassroomParticipants,
  ClassroomInvitations,
  ViewInvitations,
  ClassroomImports,
  ViewImports
} from '@/pages/Admin/Classrooms';
import { Classroom, ManageParticipants } from '@/pages/Admin/Classroom';
import { Materials, ViewMaterial } from '@/pages/Materials';
import Journey from '@/pages/Journey';
import OpenOnboarding from '@/pages/OpenOnboarding';
import { NotFound } from '@/pages/not-found';
import { Healthcheck } from '@/pages/healthcheck';
import { Taxonomies } from '@/pages/ProgramOfStudies/taxonomies';
import { QuestionsDatabase } from '@/pages/ProgramOfStudies/QuestionsDatabase';
import CreateQuestionBook from '@/pages/ProgramOfStudies/CreateQuestionBook';
import { UpdatePublicQuestions } from '@/pages/UpdatePublicQuestions';
import { UpdateQuestionBook } from '@/pages/QuestionBooks/UpdateQuestionBook';
import {
  // Projects links
  Projects,
  CreateProject,
  GroupProjects,
  IndividualProjects,
  PersonalizedProjects,
  ProjectsView,
  ProjectsAbout,
  ViewGroupProject,
  ViewIndividualProject
} from '@/pages/projects';
import { TaskManagment, ManageExcessTasks, ManageExcessStudentTasks } from '@/pages/TaskManagment';
import { StudyPlan, StudyBlock, ViewStudyPlan } from '@/pages/StudyPlan';
import { StudyGuide, StudyGuideBlock, StudyGuideSettings, StudyGuidePanorama } from '@/pages/study-guide';
import { HelpCenter, HelpViewVideo } from '@/pages/HelpCenter';
import { default as AdmQuestions, CreateQuestion, CommentQuestion } from '@/pages/Admin/Questions';
import { Exercises, ExercisesQuestions } from '@/pages/exercises';
import { PageLayouts } from '@/layouts/page-layouts';
import Example from '@/app/components/Example';
import { StudentSignUp } from '@/pages/SignUp';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';
import { Auditorium, AuditoriumView, CreateAuditorium } from '@/pages/auditorium';
import Privacy from '@/pages/Privacy';
import { LiveClasses, ViewLiveClass } from '@/pages/LiveClasses';
import { Essay, CreateEssay, EssayMonitoring, EssayCorrection, EssayConsult, EssayAbout, EssaySend, EssayPrint } from '@/pages/essay';
import { LessonPlan } from '@/pages/lesson-plan';
import { WeekChallenge } from '@/pages/week-challenge';
import { CreateWeekChallenge, ViewChallenge, ViewParticipantResult } from '@/pages/Admin/WeekChallenge';
import { Duels, DuelsPlayer } from '@/pages/duels';
import { BulletinBoards, BulletinBoardsCreate } from '@/pages/bulletin-boards';
import { CourseSchedule } from '@/pages/course-schedule';
import { PATHS } from './paths';
import { UptimeMonthlyReport } from '@/pages/reports/UptimeMonthly';

// Componente Wrapper para o Layout.
// Ele recebe o tipo de layout e renderiza o PageWithLayouts com o Outlet dentro.
const LayoutWrapper = ({ layoutType }) => {
  return (
    <PageLayouts layoutType={layoutType}>
      {/* O Outlet renderiza o componente da rota filha */}
      <Outlet />
    </PageLayouts>
  );
};

export const Routes = () => {
  const { abilities } = usePlatformAbilities();
  const sso = process.env.REACT_APP_SSO_API_URL;
  const ssoEtipi = process.env.REACT_APP_ETIPI_SSO_API_URL;

  const RedirectToSupport = () => {
    React.useEffect(() => {
      const platformSupportUrl = process.env.REACT_APP_SUPPORT_LINK;
      window.location.href = `${platformSupportUrl}/requests/new`;
    }, []);
    return null;
  };

  return (
    <RRDRoutes>
      <Route element={<LayoutWrapper layoutType="loginLayout" />}>
        <Route
          path="/login"
          element={<SignIn />}
        />
        <Route
          path="/login/:link"
          element={<SignIn />}
        />
        {(sso || ssoEtipi) && (
          <Route
            path="/login-callback"
            element={<LoginCallback />}
          />
        )}
        <Route
          path="/ajuda"
          element={<RedirectToSupport />}
        />
        <Route
          path="/inscricoes-open"
          element={<OpenRegister />}
        />{' '}
        {/* Desuso */}
        <Route
          path="/termos-de-uso"
          element={<Terms />}
        />
        <Route
          path="/politica-de-privacidade"
          element={<Privacy />}
        />
        <Route
          path="/register"
          element={<Register />}
        />
        <Route
          path="/esqueci-a-senha"
          element={<LostPassword />}
        />
        <Route
          path="/criar-uma-conta/:link/:formStep"
          element={<StudentSignUp />}
        />
        <Route
          path="/criar-uma-conta/:formStep"
          element={<StudentSignUp />}
        />
        <Route
          path="/criar-uma-conta/aluno/:link"
          element={<StudentSignUp />}
        />
        <Route
          path="/criar-uma-conta/aluno/:formStep"
          element={<StudentSignUp />}
        />
      </Route>

      <Route element={<LayoutWrapper layoutType="adminLayout" />}>
        <Route
          path="/curso/admin/gerenciar/:courseId/:moduleId/:selectedTab/:disciplineId"
          element={
            <PrivateRoute
              as={CourseManage}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/simulados/criar/:step"
          element={
            <PrivateRoute
              as={CreateMockQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path="/simulados/criar/:step/:id"
          element={
            <PrivateRoute
              as={CreateMockQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path="/simulados/:id"
          element={
            <PrivateRoute
              as={ExamsQuestions}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path="/questoes/criar/:step/:id"
          element={<PrivateRoute as={CreateQuestion} />}
        />
        <Route
          path="/questoes/criar/:step"
          element={<PrivateRoute as={CreateQuestion} />}
        />
        <Route
          path="/lms/criar/modulo/:step/:courseId"
          element={
            <PrivateRoute
              as={CreateModule}
              roleName="Criar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/criar/modulo/:step/:id/:courseId"
          element={
            <PrivateRoute
              as={CreateModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/gerenciar/modulos"
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/provas/criar/:step/:id"
          element={
            <PrivateRoute
              as={CreateExam}
              roleName="Editar provas"
              roleGroup="Provas e simulados"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/provas/criar/:step"
          element={
            <PrivateRoute
              as={CreateExam}
              roleName="Criar provas"
              roleGroup="Provas e simulados"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/avaliacoes/:selectedTab/impressao/:id"
          element={
            <PrivateRoute
              as={PrintedExam}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/apostilas/criar/:step"
          element={
            <PrivateRoute
              as={CreateQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/apostilas/criar/:step/:id"
          element={
            <PrivateRoute
              as={CreateQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/lms/gerenciar/modulo/:id"
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/gerenciar/modulo/:moduleId/:disciplineId"
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/criar/aula/:contentId/:step/:courseId"
          element={
            <PrivateRoute
              as={CreateLesson}
              roleName="Criar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/criar/aula/:contentId/:step/:lessonId/:courseId"
          element={
            <PrivateRoute
              as={CreateLesson}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/curso/atividades/criar/:step/:moduleId/:courseId"
          element={
            <PrivateRoute
              as={CourseCreateActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/curso/atividades/criar/:step/:moduleId/:courseId/:activityId"
          element={
            <PrivateRoute
              as={CourseCreateActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/projetos/criar/passo/:step"
          element={
            <PrivateRoute
              as={CreateProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/criar/passo/:step/:id"
          element={
            <PrivateRoute
              as={CreateProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/apostilas/gerenciar/:questionbookId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/apostilas/gerenciar/:questionbookId/:taxonomyId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/apostilas/gerenciar"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/simulados/gerenciar/:questionbookId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path="/simulados/gerenciar/:questionbookId/:taxonomyId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path="/simulados/gerenciar"
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path="/provas/gerenciar"
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/provas/gerenciar/:questionbookId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/provas/gerenciar/:questionbookId/:taxonomyId"
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/provas/:id"
          element={
            <PrivateRoute
              as={ExamsQuestions}
              enabled={abilities?.['avaliacoes-provas']}
            />
          }
        />
        <Route
          path="/projetos/:projectId"
          element={
            <PrivateRoute
              as={ProjectsView}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/redacao/impressao/:essayId"
          element={
            <PrivateRoute
              as={EssayPrint}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/enviar/:essayId/:studentId"
          element={
            <PrivateRoute
              as={EssaySend}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/enviar/:essayId"
          element={
            <PrivateRoute
              as={EssaySend}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/desafio-da-semana/criar"
          element={
            <PrivateRoute
              as={CreateWeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/desafio-da-semana/editar/:challengeId"
          element={
            <PrivateRoute
              as={CreateWeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/auditorio/criar/:step"
          element={
            <PrivateRoute
              as={CreateAuditorium}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path="/auditorio/editar/:step/:id"
          element={
            <PrivateRoute
              as={CreateAuditorium}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path="/redacao/criar/:step"
          element={
            <PrivateRoute
              as={CreateEssay}
              roleName={'Criar redação'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/editar/:step/:essayId"
          element={
            <PrivateRoute
              as={CreateEssay}
              enabled={abilities?.redacao}
            />
          }
        />
        {/** Relatórios */}
        <Route
          path={PATHS.REPORTS.SEDUC_PI}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPi}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GRE_QB_ROOT}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGRE}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GRE_ROOT}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGRE}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LIVE_CLASSES}
          element={<PrivateRoute as={LiveClassesReport} />}
        />
        <Route
          path={PATHS.REPORTS.RECORD_CLASSES}
          element={
            <PrivateRoute
              as={RecordClassesReport}
              roleName="Visualizar Relatório de acessos às aulas gravadas"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.REGISTRATION}
          element={
            <PrivateRoute
              as={RegistrationReport}
              roleName="Visualizar Relatório de Cadastro"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ACCESS}
          element={
            <PrivateRoute
              as={AccessReport}
              roleName="Visualizar Relatório de Mapeamento de Acesso"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.COURSE_PROGRESS}
          element={
            <PrivateRoute
              as={CourseProgressReport}
              roleName="Visualizar Progresso dos Cursos"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.QUESTIONS}
          element={
            <PrivateRoute
              as={QuestionReports}
              roleName="Visualizar Relatório de perguntas"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.QUIZ}
          element={
            <PrivateRoute
              as={QuizReport}
              roleName="Visualizar Relatório de respostas de avaliações"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LIVE_ACCESS}
          element={
            <PrivateRoute
              as={LiveLessonsAccessReport}
              roleName="Visualizar Relatório de acessos às aulas ao vivo"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ENEM}
          element={<PrivateRoute as={EnemReport} />}
        />
        <Route
          path={PATHS.REPORTS.ACCESS_FUNNEL}
          element={
            <PrivateRoute
              as={AccessFunnelReport}
              roleName="Visualizar Relatório de Funil de Acessos"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ADHERENCE}
          element={
            <PrivateRoute
              as={GeneralRegistrationReport}
              roleName="Visualizar Relatório de Adesão"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ESSAY}
          element={
            <PrivateRoute
              as={EssayReport}
              roleName="Visualizar Redações"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ESSAY_STUDENT_ROOT}
          element={<PrivateRoute as={StudentPage} />}
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GERAL}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGeral}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LEVELING_TEST}
          element={<PrivateRoute as={LevelingTestReport} />}
        />
        <Route
          path={PATHS.REPORTS.UPTIME_MONTHLY}
          element={
            <PrivateRoute
              as={UptimeMonthlyReport}
              roleName="Visualizar Relatório de Disponibilidade"
              RoleGroup="Relatórios"
            />
          }
        />
        <Route
          path="/curso/criar/:step/:id"
          element={<PrivateRoute as={CourseCreate} />}
        />
        <Route
          path="/curso/criar/:step"
          element={<PrivateRoute as={CourseCreate} />}
        />
        {/* Banners */}
        <Route
          path="/banners/novo/:id"
          element={
            <PrivateRoute
              as={BulletinBoardsCreate}
              roleName="Editar Mural"
              RoleGroup="Mural"
            />
          }
        />
        <Route
          path="/banners/novo"
          element={
            <PrivateRoute
              as={BulletinBoardsCreate}
              roleName="Criar Mural"
              RoleGroup="Mural"
            />
          }
        />
      </Route>
      {/** Fim das Rotas de Admin Layout */}

      <Route element={<LayoutWrapper layoutType="mainLayout" />}>
        <Route
          path="/"
          element={
            <PrivateRoute
              as={Dashboard}
              enabled={abilities?.dashboard}
            />
          }
        />
        <Route
          path="/evento/:eventId"
          element={<PrivateRoute as={ViewEvent} />}
        />
        <Route
          path="/open-results/:id"
          element={<PrivateRoute as={OpenResults} />}
        />
        <Route
          path="/answer-book/:id"
          element={<PrivateRoute as={OpenAnswerBook} />}
        />
        <Route
          path="/admin-dashboard" //desuso
          element={<PrivateRoute as={Dashboard} />}
        />
        <Route
          path="/minhas-tarefas/:taskType/:taskId"
          element={
            <PrivateRoute
              as={ViewTask}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path="/minhas-tarefas"
          element={
            <PrivateRoute
              as={MyTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path="/feed"
          element={
            <PrivateRoute
              as={Feed}
              roleName="Visualizar postagens e comentários"
              roleGroup="Fórum"
              enabled={abilities?.feed}
            />
          }
        />
        <Route
          path="/gestao-de-tarefa/:selectedTab"
          element={
            <PrivateRoute
              as={TaskManagment}
              roleName="Visualizar Tarefas"
              roleGroup="Tarefas"
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path="/gestao-de-tarefa/:selectedTab/tarefas/:studentId"
          element={
            <PrivateRoute
              as={ManageExcessStudentTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path="/gestao-de-tarefa/:selectedTab/tarefas"
          element={
            <PrivateRoute
              as={ManageExcessTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        {/* Course routes */}
        <Route
          path="/curso/recomendado"
          element={
            <PrivateRoute
              as={CourseRecommended}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso/certificado"
          element={
            <PrivateRoute
              as={CourseCertificate}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso/acompanhamento/:id"
          element={
            <PrivateRoute
              as={CourseMonitoring}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso/:courseId/modulo/:moduleId/:selectedTab"
          element={
            <PrivateRoute
              as={CourseModuleAbout}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso"
          element={
            <PrivateRoute
              as={Course}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso/admin/:id"
          element={
            <PrivateRoute
              as={CourseAbout}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/curso/admin"
          element={
            <PrivateRoute
              as={CourseAdmin}
              enabled={abilities?.cursos}
            />
          }
        />
        {/* Classrooms routes */}
        <Route
          path="/turmas/importar/:importId"
          element={
            <PrivateRoute
              as={ViewImports}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/turmas/importar"
          element={
            <PrivateRoute
              as={ClassroomImports}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/turmas/convites/:inviteId"
          element={
            <PrivateRoute
              as={ViewInvitations}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/turmas/convites"
          element={
            <PrivateRoute
              as={ClassroomInvitations}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/turmas/gerenciar/:classroomId"
          element={
            <PrivateRoute
              as={ManageClassroomParticipants}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path="/turmas"
          element={
            <PrivateRoute
              as={Classrooms}
              enabled={abilities?.cursos}
            />
          }
        />

        <Route
          path="/lms/visualizar/modulo/:id"
          element={
            <PrivateRoute
              as={ViewModule}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/visualizar/modulo/:id/disciplina/:disciplineId"
          element={
            <PrivateRoute
              as={Lesson}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms/visualizar/modulo/:id/disciplina/:disciplineId/aula/:lessonId"
          element={
            <PrivateRoute
              as={LessonResources}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/lms"
          element={
            <PrivateRoute
              as={LmsStudent}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/show-course/:id"
          element={<PrivateRoute as={ShowCourse} />}
        />
        <Route
          path="/show-course/:id/classroom"
          element={<PrivateRoute as={CourseClassroom} />}
        />
        <Route
          path="/show-course/:id/classroom/:lessonId"
          element={<PrivateRoute as={CourseClassroom} />}
        />

        <Route
          path="/plano-de-estudos"
          element={
            <PrivateRoute
              as={StudyPlan}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/guia-de-estudos/bloco-de-estudo/:blockId"
          element={
            <PrivateRoute
              as={StudyGuideBlock}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/guia-de-estudos/funcionamento"
          element={
            <PrivateRoute
              as={StudyGuidePanorama}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/guia-de-estudos/configuracao"
          element={
            <PrivateRoute
              as={StudyGuideSettings}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/guia-de-estudos"
          element={
            <PrivateRoute
              as={StudyGuide}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/questions/:selectedTab"
          element={
            <PrivateRoute
              as={Exercises}
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/questions/:selectedTab/:id"
          element={
            <PrivateRoute
              as={ExercisesQuestions}
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path="/materiais/:materialId/:moduleId"
          element={
            <PrivateRoute
              as={ViewMaterial}
              enabled={abilities?.['cursos-materiais']}
            />
          }
        />
        <Route
          path="/materiais"
          element={
            <PrivateRoute
              as={Materials}
              enabled={abilities?.['cursos-materiais']}
            />
          }
        />
        <Route
          path="/metricas/institucional/engajamento/turma/:classroomId"
          element={
            <PrivateRoute
              as={ViewClassroom}
              roleName="Visualizar dados e métricas"
              roleGroup={['Questionário de Percepção', 'Cursos', 'Projetos', 'Participantes e perfis administrativos', 'Questões e exercícios', 'Avaliações', 'Taxonomias', 'Arquivos e atividades complementares', 'Fórum', 'Tarefas']}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route //metabase
          path="/metricas/:selectedTab/:reportId"
          element={
            <PrivateRoute
              as={ShowEmbed}
              roleName={['Visualizar dados e métricas', 'Mantenedor', 'Institucional', 'Regional']}
              roleGroup={[
                'Questionário de Percepção',
                'Cursos',
                'Projetos',
                'Participantes e perfis administrativos',
                'Questões e exercícios',
                'Avaliações',
                'Taxonomias',
                'Arquivos e atividades complementares',
                'Fórum',
                'Turmas',
                'Tarefas',
                'Relatórios'
              ]}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route //metabase
          path="/metricas/:selectedTab"
          element={
            <PrivateRoute
              as={Reports}
              roleName={['Visualizar dados e métricas', 'Mantenedor', 'Institucional', 'Regional']}
              roleGroup={[
                'Questionário de Percepção',
                'Cursos',
                'Projetos',
                'Participantes e perfis administrativos',
                'Questões e exercícios',
                'Avaliações',
                'Taxonomias',
                'Arquivos e atividades complementares',
                'Fórum',
                'Cursos',
                'Tarefas',
                'Relatórios',
                'Turmas'
              ]}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path="/metricas-1"
          element={
            <PrivateRoute
              as={Metrics1}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path="/metricas/perfil/:id"
          element={
            <PrivateRoute
              as={MetricsProfile}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path="/questionario"
          element={
            <PrivateRoute
              as={Quiz}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path="/questionario/dados/:id"
          element={
            <PrivateRoute
              as={QuizData}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path="/questionario/:representation/:surveyId/estudante/:studentId"
          element={
            <PrivateRoute
              as={QuizDataOpenAnswers}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path="/questionario/criar/:representation/:id"
          element={
            <PrivateRoute
              as={QuizCreate}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path="/questionario/:representation/:id"
          element={
            <PrivateRoute
              as={QuizData}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path="/questionario/dados/:surveyId/propostas/:questionId"
          element={
            <PrivateRoute
              as={QuizDataProposal}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        {/* atividades complementares */}
        <Route
          path="/atividade-complementar"
          element={
            <PrivateRoute
              as={ComplementaryActivity}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/atividade-complementar/:activityId/:courseId"
          element={
            <PrivateRoute
              as={ViewActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/atividade-complementar/atividade/:id"
          element={
            <PrivateRoute
              as={ComplementaryActivityDetails}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path="/atividade-complementar/avaliacao/:activityId/:id"
          element={
            <PrivateRoute
              as={ComplementaryActivityEvaluationView}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path="/atividade-complementar/avaliar-atividades/:id"
          element={
            <PrivateRoute
              as={ActivityEvaluationArchive}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path="/atividade-complementar/avaliar/:activityId/:id"
          element={
            <PrivateRoute
              as={ActivityEvaluation}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/atividade-complementar/dados/:id"
          element={
            <PrivateRoute
              as={ActivityData}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path="/admin"
          element={<PrivateRoute as={DashboardAdmin} />}
        />
        <Route
          path="/classrooms"
          element={
            <PrivateRoute
              as={Classroom}
              roleName="Visualizar lista de turmas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/turma"
          element={
            <PrivateRoute
              as={Classroom}
              roleName="Visualizar lista de cursos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/classrooms/:courseId/:institutionId"
          element={<PrivateRoute as={Classroom} />}
        />
        <Route
          path="/course/create/participant"
          element={
            <PrivateRoute
              as={CreateOrUpdateParticipant}
              roleName={'Visualizar lista de cursos' || 'Visualizar lista de turmas'}
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path="/course/edit/participant/:id"
          element={<PrivateRoute as={CreateOrUpdateParticipant} />}
        />
        <Route
          path="/classrooms/:classroomId/gerenciar"
          element={<PrivateRoute as={ManageParticipants} />}
        />
        <Route
          path="/jornada"
          element={
            <PrivateRoute
              as={Journey}
              // enabled={abilities?.jornada}
            />
          }
        />
        <Route
          path="/posts/:slug"
          element={
            <PrivateRoute
              as={FeedPost}
              roleName="Visualizar postagens e comentários"
              roleGroup="Fórum"
            />
          }
        />
        <Route
          path="/simulados"
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path="/minha-inscricao"
          element={<PrivateRoute as={OpenOnboarding} />}
        />
        <Route
          path="/profile"
          element={<PrivateRoute as={Profile} />}
        />
        <Route
          path="/participantes/notificacoes/extrato"
          element={
            <PrivateRoute
              as={NotificationExtract}
              roleName="Enviar notificações de engajamento"
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path="/participantes/notificacoes"
          element={
            <PrivateRoute
              as={Notifications}
              roleName="Enviar notificações de engajamento"
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path="/participantes/perfis-administrativos/:id"
          element={<PrivateRoute as={ManageProfile} />}
        />
        <Route
          roleName="Visualizar lista e gerenciar perfis"
          roleGroup="Participantes e perfis administrativos"
          path="/participantes/perfis-administrativos"
          element={<PrivateRoute as={AdministrativeProfiles} />}
        />
        <Route
          path="/participantes"
          element={
            <PrivateRoute
              as={Participants}
              roleName={['Visualizar lista de participantes', 'Visualizar lista e gerenciar perfis', 'Enviar notificações de engajamento']}
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path="/usuario/:selectedTab/:id"
          element={
            <PrivateRoute
              as={UsersShow}
              enabled={abilities?.jornada}
            />
          }
        />
        <Route
          path="/projetos/grupos/:groupId/:projectId/sobre"
          element={
            <PrivateRoute
              as={ProjectsAbout}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/:projectId/sobre"
          element={
            <PrivateRoute
              as={ProjectsAbout}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/grupos/:id"
          element={
            <PrivateRoute
              as={ViewGroupProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/grupos"
          element={
            <PrivateRoute
              as={GroupProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/individuais/:id"
          element={
            <PrivateRoute
              as={ViewIndividualProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/individuais"
          element={
            <PrivateRoute
              as={IndividualProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos/personalizados"
          element={
            <PrivateRoute
              as={PersonalizedProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path="/projetos"
          element={
            <PrivateRoute
              as={Projects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        {/** Redação * */}
        <Route
          path="/redacao/consulta/:essayId/:studentId"
          element={
            <PrivateRoute
              as={EssayConsult}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/sobre/:essayId"
          element={
            <PrivateRoute
              as={EssayAbout}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/correcao/:studentId/:essayId"
          element={
            <PrivateRoute
              as={EssayCorrection}
              roleName={'Realizar correção'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/visualizar/:studentId/:essayId"
          element={
            <PrivateRoute
              as={EssayCorrection}
              roleName={'Visualizar redação'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/consulta/:essayId/:studentId"
          element={
            <PrivateRoute
              as={EssayConsult}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao/acompanhamento/:essayId"
          element={
            <PrivateRoute
              as={EssayMonitoring}
              roleName={['Realizar correção', 'Visualizar redação']}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path="/redacao"
          element={
            <PrivateRoute
              as={Essay}
              enabled={abilities?.redacao}
            />
          }
        />
        {/** Ementa * */}
        <Route
          path="/ementa/materias"
          element={
            <PrivateRoute
              as={Taxonomies}
              roleName="Visualizar lista de ementas, tópicos e subtópicos"
              roleGroup="Ementas"
            />
          }
        />
        {/** Banners * */}
        <Route
          path="/banners"
          element={
            <PrivateRoute
              as={BulletinBoards}
              roleName="Visualizar Mural"
              RoleGroup="Mural"
            />
          }
        />
        {/** Gerenciamento de provas * */}
        <Route
          path="/provas/banco-de-questoes/comentar/:questionId"
          element={<PrivateRoute as={CommentQuestion} />}
        />
        <Route
          path="/avaliacoes/:selectedTab/offline/:id"
          element={
            <PrivateRoute
              as={OfflineExam}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/avaliacoes/:selectedTab"
          element={
            <PrivateRoute
              as={Exams}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/resultado-das-provas/"
          element={
            <PrivateRoute
              as={Exams}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path="/lista-resultado-das-provas/:id"
          element={
            <PrivateRoute
              as={ExamMetricsList}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path="/simulados/sobre/:id"
          element={
            <PrivateRoute
              as={MockExamsAbout}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path="/avaliacoes/sobre/:id"
          element={
            <PrivateRoute
              as={ExamsAbout}
              enabled={abilities?.['avaliacoes-provas']}
            />
          }
        />
        <Route
          path="/avaliacoes"
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/avaliacoes/meus-resultados"
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path="/provas/resultados"
          element={
            <PrivateRoute
              as={ExamMetrics}
              roleName={'Visualizar resultados'}
              roleGroup={'Avaliações'}
            />
          }
        />
        <Route
          path="/ementa/banco-de-questoes"
          element={
            <PrivateRoute
              as={QuestionsDatabase}
              roleName="Visualizar banco de questões"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path="/ementa/questoes-publicas"
          element={<PrivateRoute as={UpdatePublicQuestions} />}
        />
        <Route
          path="/ementa/cadernos-de-questoes/:questionBookId"
          element={<PrivateRoute as={UpdateQuestionBook} />}
        />
        <Route
          path="/plano-de-estudos/:planId/bloco-de-estudos/:blockId"
          element={
            <PrivateRoute
              as={StudyBlock}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/plano-de-estudos/:planId"
          element={
            <PrivateRoute
              as={ViewStudyPlan}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path="/ajuda/:id"
          element={<PrivateRoute as={HelpViewVideo} />}
        />
        <Route
          path="/componentes"
          element={<PrivateRoute as={Example} />}
        />
        <Route
          path="/auditorio/:auditoriumId"
          element={
            <PrivateRoute
              as={AuditoriumView}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path="/auditorio"
          element={<PrivateRoute as={Auditorium} />}
        />
        <Route
          path="/aulas-ao-vivo/:liveClassId"
          element={
            <PrivateRoute
              as={ViewLiveClass}
              enabled={abilities?.['aulas-ao-vivo']}
              roleGroup="Aulas ao vivo"
              roleName="Visualizar aulas ao vivo"
            />
          }
        />
        <Route
          path="/aulas-ao-vivo"
          element={
            <PrivateRoute
              as={LiveClasses}
              roleGroup="Aulas ao vivo"
              roleName="Visualizar aulas ao vivo"
              enabled={abilities?.['aulas-ao-vivo']}
            />
          }
        />
        <Route
          path="/desafio-da-semana/:selectedTab/:studentId/:profile/:challengeId"
          element={
            <PrivateRoute
              as={ViewParticipantResult}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/desafio-da-semana/:selectedTab/:challengeId"
          element={
            <PrivateRoute
              as={ViewChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/desafio-da-semana/:selectedTab"
          element={
            <PrivateRoute
              as={WeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/desafio-da-semana"
          element={
            <PrivateRoute
              as={WeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path="/duelos"
          element={<PrivateRoute as={Duels} />}
        />
        <Route
          path="/duelos/:duelId"
          element={<PrivateRoute as={DuelsPlayer} />}
        />
        <Route
          path={PATHS.LESSON_PLAN.ROOT}
          element={
            <PrivateRoute
              as={LessonPlan}
              enabled={abilities?.['plano-de-aula']}
            />
          }
        />
        <Route
          path="/grade-horaria"
          element={<PrivateRoute as={CourseSchedule} />}
        />
      </Route>
      {/** Fim das Rotas de Main Layout */}

      <Route
        path="/healthcheck"
        element={<Healthcheck />}
      />

      <Route
        path="*"
        element={<NotFound />}
      />
    </RRDRoutes>
  );
};
